import api from '../api';

export const recordView = (data) => api.post('/core/functions/recordView', data);

export const sendEvent = (data) => api.post('/core/functions/sendEvent', data);

export const fetchMetrics = (data) => api.post('/core/functions/fetchMetrics', data);
